export const useRedirectUrl = () => {
  const getRedirectUrl = (locale: string) => {
    const currentUrl = new URL(window.location.href)
    const redirectUrlParam = currentUrl.searchParams.get('redirectURL')
    if (!redirectUrlParam) {
      return null
    }

    const redirectUrl = new URL(`${currentUrl.protocol}//${redirectUrlParam}`)

    currentUrl.searchParams.forEach((value, key) => {
      if (key !== 'redirectURL') {
        redirectUrl.searchParams.set(key, value)
      }
    })

    return redirectUrl.href.replace(':locale', locale)
  }

  return { getRedirectUrl }
}
